// Spanish-aware title case: primera letra de cada palabra en mayuscula,
// resto en minuscula, EXCEPTO conectores (de, del, la, etc.) que quedan
// en minuscula salvo que sean la primera palabra.
const SMALL_WORDS = new Set([
  'de', 'del', 'la', 'las', 'el', 'los', 'y', 'e', 'en', 'a', 'al',
]);
export const toTitleCase = (s: string): string => {
  if (!s) return s;
  return s
    .toLowerCase()
    .split(/\s+/)
    .map((w, i) => {
      if (i > 0 && SMALL_WORDS.has(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(' ');
};
